// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__mHNLT","productName":"Table_productName__1P6p4"};